import React from 'react';
import { compose } from 'recompose';
import { withLocalize } from 'react-localize-redux';
import { withRouter } from 'react-router-dom';
import { Image, Divider } from 'semantic-ui-react';
import styled from 'styled-components';
import { Tag } from '../../../../uiStandard/event/tag';
// import { Label } from '../../../../uiStandard/event/label';
import { Button } from '../../../../uiStandard/event/button';

const PositionTileBase = (props) => {
  const { post, translate } = props;
  const {
    company, name, content, postingSlug
  } = post;

  return (
    <Card>
      <CardHead>
        {company.logoUrl && (
          <Image src={company.logoUrl} className='cardImg' alt={company.name} />
        )}
        <CompanyInfo>
          <Role>{name}</Role>
          <CompanyName>{company.name}</CompanyName>
          {/* <Tag iconName='location' label={company.address} card /> */}
        </CompanyInfo>
      </CardHead>
      <CardContent>
        {/* <Role>{name}</Role> */}
        {/* <Salary>$75,000 - $85,000 a year</Salary>
        <LabelContainer>
          <Label category='category' label='Typescript' isRound />
          <Label category='category' label='JavaScript' isRound />
          <Label category='category' label='HTML/CSS' isRound />
          <Label category='category' label='3 years experience' isRound />
          <Label category='category' label='Angular' isRound />
          <Label category='category' label='React' isRound />
        </LabelContainer> */}
        <Description>{content}</Description>
      </CardContent>
      <DividerContainer>
        <Divider fitted />
      </DividerContainer>
      <StyledLink
        href={`https://talent-gamma.hackhub.com/posting/${postingSlug}/apply`}
        target='_blank' rel='noreferrer'
      >
        {translate('apply')}
      </StyledLink>
    </Card>
  );
};

export const PositionTile = compose(withLocalize, withRouter)(PositionTileBase);

const RelatedPositionTileBase = (props) => {
  const { post, translate } = props;
  const {
    slug, companyLogo, title, content, companyName, companyAddress 
  } = post;
  return (
    <RelatedPosCard>
      <CardHead>
        <Image src={companyLogo} className='cardImg' alt={companyName} />
        <CompanyInfo>
          <CompanyName>{companyName}</CompanyName>
          <Tag iconName='location' label={companyAddress } card />
        </CompanyInfo>
      </CardHead>
      <CardContent>
        <Role>{title}</Role>
        {/* <Salary>$75,000 - $85,000 a year</Salary>
        <LabelContainer>
          <Label category='category' label='Typescript' isRound />
          <Label category='category' label='JavaScript' isRound />
          <Label category='category' label='HTML/CSS' isRound />
          <Label category='category' label='3 years experience' isRound />
          <Label category='category' label='Angular' isRound />
          <Label category='category' label='React' isRound />
        </LabelContainer> */}
        <Description>{content}</Description>
      </CardContent>
      <BtnWrapper href={`https://talent-gamma.hackhub.com/posting/${slug}/apply`} target='_blank' rel='noreferrer'>
        <Button isSmall label={translate('apply')} />
      </BtnWrapper>
    </RelatedPosCard>
  );
};

export const RelatedPositionTile = compose(withLocalize, withRouter)(RelatedPositionTileBase);


const Card = styled.div`
  width: 100%;
  min-height: 230px;
  height: auto;
  background: #FFFFFF;
  box-shadow: 0px 1px 3px rgba(16, 24, 40, 0.1), 0px 1px 2px rgba(16, 24, 40, 0.06);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  jusity-content:space-around;
  margin: 0 auto;
  transition: all 0.1s linear;
  padding: 0.4em 0 4em 0;
  position: relative;
  :hover {
    transform: translateY(-5px);
  }

  @media only screen and (max-width: 288px) {
    width: 100%;
  }
`;

const RelatedPosCard = styled(Card)`
  margin: 1rem auto;
  max-width: 288px;
  width: 100%;
  text-align:center;
`;

const CardHead = styled.div`
  display: flex;
  width: 90%;
  padding: 0.4em;
  margin: auto;
  .cardImg {
    width: 48px;
    height: 48px;
    border-radius: 33.5px;
    object-fit:cover;
  }
  span:last-of-type {
    font-weight: 500;
    margin: 0;
    padding: 0.1em 0.2em;
  }  
`;

const CompanyInfo = styled.div`
  min-height: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content:center;
  align-items:flex-start;
  min-width: 50%;
  padding: 0.2em 0 0.2em 1em;

  span:last-of-type {
    font-weight: 500;
    height: fit-content;
    display: inline-flex;
    justify-content:center;
    font-size: 16px;
    line-height: 19px;
    span {
      text-align:left;
    }
  }
`;

const CompanyName = styled.span`
  display: inline-block;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #667085;
  padding: 0.2em 0 1em 0.2em;
  display: inline-block; 
`;


const CardContent = styled.div`
  width: 100%;   
  display: flex;
  flex-direction: column;
  justify-content:space-around;
  position: relative;
  padding: 0 0.4em;
  span {
    display: inline-block;
    padding-top: 0.4em;
  }  
`;

const Role = styled.span`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #101828;
  text-align:left;  
`;

// const Salary = styled.span`
//     font-family: 'Quicksand';
//     font-style: normal;
//     font-weight: 600;
//     font-size: 16px;
//     line-height: 20px;
//     color: #0094FB;
//     padding-bottom: 0.8em;
// `;

// const LabelContainer = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   justify-content:center;
//     span {
//       margin: 1px;
//       font-size: 12px;
//       padding: 0.2em 0.6em;
//     }
//   }
// `;

const BtnWrapper = styled.a`
  &&& {
    width: 171px;
    position: absolute;
    bottom: 0.8em;
    left: 50%;
    transform: translate(-50%);
    
    button {
      margin: 0;
      width: 100%;
    }
  }
`;

const DividerContainer = styled.div`
  position: absolute;
  bottom: 3em;
  right: 0;
  width: 100%;
`;

const StyledLink = styled.a`
  &&& {
      position: absolute;
    bottom: 1.5em;
    transform: translateY(50%);
    right: 0.4em;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #0094FB;
  }
`;


const Description = styled.p`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-align:left;
  padding: 0 0.2em;
  color: #809FB8;
  max-width: 100%;
  padding-top: 0.8em;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;



// WEBPACK FOOTER //
// ./src/components/events/components/tile/positionTile.js